// src/types/AvailableWidgets.ts

import { WeatherMapWidget } from '../widgets/WeatherMapWidget';
import { SetMemoryWidget } from '../widgets/SetMemoryWidget';
import { PerceptionWidget } from '../widgets/PerceptionWidget';
import { KnowledgeWidget } from '../widgets/KnowledgeWidget';
import { BuilderViewWidget } from '../widgets/BuilderViewWidget';
import { ControlLightsWidget } from '../widgets/ControlLightsWidget';
import { ChatDefaultWidget } from '../widgets/ChatDefaultWidget';

export const AvailableWidgets: WidgetDescription[] = [
    {
        key: 'ChatDefaultWidget',
        displayName: 'conversation',
        component: ChatDefaultWidget,
    },
    {
        key: 'PerceptionWidget',
        displayName: 'perception',
        component: PerceptionWidget,
    },
    {
        key: 'KnowledgeWidget',
        displayName: 'memory',
        component: KnowledgeWidget,
    },
    {
        key: 'BuilderViewWidget',
        displayName: 'builder viewer',
        component: BuilderViewWidget,
    },
    {
        key: 'WeatherMapWidget',
        displayName: 'get_weather()',
        component: WeatherMapWidget,
    },
    {
        key: 'ControlLightsWidget',
        displayName: 'control_lights()',
        component: ControlLightsWidget,
    },
    {
        key: 'SetMemoryWidget',
        displayName: 'set_memory()',
        component: SetMemoryWidget,
    }
];

export interface WidgetDescription {
    key: string;
    displayName: string;
    component: React.ComponentType<any>;
}